
import { useState, useEffect } from "react";

interface CountdownTimerProps {
  targetDate: Date;
  className?: string;
}

const CountdownTimer = ({ targetDate, className = "" }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = targetDate.getTime() - new Date().getTime();
      
      if (difference <= 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Initial calculation
    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [targetDate]);

  const formatNumber = (num: number): string => {
    return num < 10 ? `0${num}` : num.toString();
  };

  return (
    <div className={`flex justify-center gap-4 md:gap-8 text-center ${className}`}>
      <div className="flex flex-col items-center">
        <div className="bg-white/90 dark:bg-gray-800/90 text-nation-blue rounded-lg shadow-lg w-16 md:w-24 h-16 md:h-24 flex items-center justify-center">
          <span className="text-2xl md:text-4xl font-bold">{formatNumber(timeLeft.days)}</span>
        </div>
        <span className="text-xs md:text-sm mt-2 font-medium">DAYS</span>
      </div>
      
      <div className="flex flex-col items-center">
        <div className="bg-white/90 dark:bg-gray-800/90 text-nation-blue rounded-lg shadow-lg w-16 md:w-24 h-16 md:h-24 flex items-center justify-center">
          <span className="text-2xl md:text-4xl font-bold">{formatNumber(timeLeft.hours)}</span>
        </div>
        <span className="text-xs md:text-sm mt-2 font-medium">HOURS</span>
      </div>
      
      <div className="flex flex-col items-center">
        <div className="bg-white/90 dark:bg-gray-800/90 text-nation-blue rounded-lg shadow-lg w-16 md:w-24 h-16 md:h-24 flex items-center justify-center">
          <span className="text-2xl md:text-4xl font-bold">{formatNumber(timeLeft.minutes)}</span>
        </div>
        <span className="text-xs md:text-sm mt-2 font-medium">MINUTES</span>
      </div>
      
      <div className="flex flex-col items-center">
        <div className="bg-white/90 dark:bg-gray-800/90 text-nation-blue rounded-lg shadow-lg w-16 md:w-24 h-16 md:h-24 flex items-center justify-center">
          <span className="text-2xl md:text-4xl font-bold">{formatNumber(timeLeft.seconds)}</span>
        </div>
        <span className="text-xs md:text-sm mt-2 font-medium">SECONDS</span>
      </div>
    </div>
  );
};

export default CountdownTimer;
